import type { ShareChannel } from '#src/app/pages/psf/share/shared/types';

export const SHARE_CHANNELS: Partial<Record<ShareChannel, true>> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	instagramStories: true,
	line: true,
	mobileNativeShare: true,
	nextdoor: true,
	reddit: true,
	sms: true,
	tiktok: true,
	twitter: true,
	vk: true,
	whatsapp: true,
};

export const SHARE_GOAL_COUNTER_STEPS = 3;

/**
 * How long the completed counter's celebration plays before moving on: the counter's reveal delay (0.3s) plus
 * its longest confetti piece (0.25s delay + 1.18s), rounded up.
 */
export const SHARE_GOAL_COUNTER_CELEBRATION_MS = 1800;

/**
 * How long a page that lost focus but is still visible counts as left. Chrome on iOS keeps a page visible for
 * ~0.9s while it animates to a tab the page opened, so a real switch is hidden well within this; past it the
 * blur was something else (an iframe, split screen) and the supporter is still here.
 */
export const LEAVING_FALLBACK_MS = 1500;

/**
 * How long the counter waits for the page to hide after a share that hands off to another app. iOS and
 * Android only report it hidden once the switch has finished (~1s on Chrome iOS); if it never hides (app not
 * installed, "Open in app?" cancelled), the supporter is still here.
 */
export const EXPECTED_LEAVE_FALLBACK_MS = 2500;

/**
 * Chrome on Android hides the page for this long at most when it opens and closes an app link's tab, before
 * the app is up (20–100ms measured); a real trip away and back takes longer.
 */
export const HANDOFF_FLIP_MAX_MS = 500;

/**
 * How long the counter waits for the app once Chrome on Android has shown that it's launching one (~1.1–1.3s
 * measured on a mid-range phone; slower on a cold start).
 */
export const APP_LAUNCH_FALLBACK_MS = 5000;

/**
 * Extra wait past the first frame after the supporter is back on Android, whose return animation (336ms on
 * Pixel, ~450ms measured on MIUI) shows a snapshot while the page already reports visible.
 */
export const RETURN_SETTLE_MS = 300;
